<template>
  <aside class="site-sidebar" :class="'site-sidebar--' + sidebarLayoutSkin" style="box-shadow: 0 0 6px 0 rgba(219,237,235,1)">
    <div class="site-sidebar__inner">
      <el-menu
        :default-active="menuActiveName || 'home'"
        :collapse="sidebarFold"
        :unique-opened="true"
        :collapseTransition="false"
        class="site-sidebar__menu">
<!--        <el-menu-item index="home" class="home" @click="$router.push({ name: 'home' })">-->
<!--           <icon-svg name="shouye1" class="site-sidebar__menu-icon"></icon-svg>-->
<!--           <span style="color: #333333;font-weight:bold">首页</span>-->
<!--        </el-menu-item>-->
<!--        <el-divider></el-divider>-->
        <sub-menu
          :menuPopup="false"
          :menuLevel="dafaultLevel"
          v-for="menu in currentMenuList"
          :key="menu.menuId"
          :menu="menu"
          :dynamicMenuRoutes="dynamicMenuRoutes">
      </sub-menu>
      </el-menu>
<!--      <el-menu-->
<!--              style="position: fixed;bottom: 0"-->
<!--              :unique-opened="true"-->
<!--              :collapse="sidebarFold"-->
<!--              :collapseTransition="false"-->
<!--              class="site-sidebar__menu">-->
<!--        <el-divider></el-divider>-->
<!--        <el-menu-item class="site-navbar__switch" index="0" @click="sidebarFold = !sidebarFold">-->
<!--          <icon-svg name="zhedie" class="site-sidebar__menu-icon"></icon-svg>-->
<!--          <el-button type="text">点击折叠</el-button>-->
<!--        </el-menu-item>-->
<!--      </el-menu>-->
    </div>
  </aside>
</template>

<script>
    import SubMenu from './main-sidebar-sub-menu'
    import {isURL} from '@/utils/validate'
    import {getParameterByName} from "@/utils";

    export default {
    data() {
      return {
        dynamicMenuRoutes: [],
        currentMenuList: [],
        dafaultLevel:1,
        oldTabIndex:0
      }
    },
    components: {
      SubMenu
    },
    computed: {
      sidebarLayoutSkin: {
        get() {
          return this.$store.state.common.sidebarLayoutSkin
        }
      },

      sidebarFold: {
        get () { return this.$store.state.common.sidebarFold },
        set (val) { this.$store.commit('common/updateSidebarFold', val) }
      },

      hasLogin: {
        get () { return this.$store.state.user.id !== '' && this.$store.state.user.id !== undefined }
      },
      topNavIndex: {
        get () { return this.$store.state.common.topNavIndex },
      },
      menuList: {
        get() {
          return this.$store.state.common.menuList
        },
        set(val) {
          this.$store.commit('common/updateMenuList', val)
        }
      },
      menuActiveName: {
        get() {
          return this.$store.state.common.menuActiveName
        },
        set(val) {
          this.$store.commit('common/updateMenuActiveName', val)
        }
      },
      mainTabs: {
        get() {
          return this.$store.state.common.mainTabs
        },
        set(val) {
          this.$store.commit('common/updateMainTabs', val)
        }
      },
      mainTabsActiveName: {
        get() {
          return this.$store.state.common.mainTabsActiveName
        },
        set(val) {
          this.$store.commit('common/updateMainTabsActiveName', val)
        }
      }
    },
    watch: {
      $route: 'routeHandle',
      '$store.state.common.topNavIndex': function () {
        if(this.oldTabIndex!==this.topNavIndex){
          this.oldTabIndex=this.topNavIndex
          this.loadMenuList()
        }
      }
    },
    created() {
      this.oldTabIndex=this.topNavIndex
      this.loadMenuList()
      this.$bus.$on('updateMenuList', (mlist) => {
        this.currentMenuList = mlist
        const firstRoute = mlist[0]
        this.menuActiveName = firstRoute.menuId
        this.$router.push({ path: firstRoute.url })
      })
    },
    methods: {
      loadMenuList(){
        this.menuList = JSON.parse(sessionStorage.getItem('menuList') || '[]')
        this.currentMenuList=this.menuList
        this.dynamicMenuRoutes = JSON.parse(sessionStorage.getItem('dynamicMenuRoutes') || '[]')
        this.routeHandle(this.$route)
      },
      // 路由操作
      routeHandle(route) {
        if (route.meta.isTab) {
          let routeName = route.name
          let tabName = routeName
          if (!route.meta.isDynamic && route.params && route.meta.single !== true) {
            let extname = ''
            for (var argname in route.params) {
              if (route.params[argname]) {
                extname += '_' + route.params[argname]
              }
            }
            tabName = tabName + extname
          }
          // tab选中, 不存在先添加
          var tab = this.mainTabs.filter(item => item.name === tabName)[0]
          if (!tab) {
            if (route.meta.isDynamic) {
              if (!route) {
              route = this.dynamicMenuRoutes.filter(item => item.name === tabName)[0]
                return console.error('未能找到可用标签页!')
              }
            }
            let title = route.meta.title
            // if (route.params && route.params.title) {
            //   title = route.params.title
            // }
            tab = {
              menuId: route.meta.menuId || tabName,
              name: tabName,
              routeName: routeName,
              params: route.params || {}, //用于记录路由参数
              query: route.query || {}, //用于记录路由参数
              title: title,
              type: isURL(route.meta.iframeUrl) ? 'iframe' : 'module',
              iframeUrl: route.meta.iframeUrl || ''
            }
            this.mainTabs = this.mainTabs.concat(tab)
          }
          this.menuActiveName = tab.menuId + ''
          this.mainTabsActiveName = tabName
        }

        let path = route.path;
        // 项目见证受理详情页,左侧菜单对应选中修改
        if(route.path == "/businessflowWitness/list_detail"){
          path = "/businessflowWitness_" + route.query.businessType  + "/list"
        }
        // 项目见证记录详情页 左侧菜单对应选中修改
        if(route.path == "/businessWitnessHis/list_detail"){
          path = "/businessWitnessHis_" + route.query.businessType + "/list"
        }
        let obj = this.recursion(this.menuList, path);
        if(obj != null){
          this.$bus.$emit('initMenuId', obj.menuId)
          this.menuActiveName = obj.menuId || ""
        }


      },
      recursion(data, path) {
        if(!data){
          return;
        }
        // 从 path中拿到菜单目录
        let pathArr = path.split("/");
        let activePathName =pathArr.length>2?pathArr[pathArr.length-2]:(pathArr[1] || pathArr[0]);
        var result = null;

        for(var i in data){
          if(result !== null) {
            break;
          }
          var item = data[i];

          // type == 1 代表菜单地址
          if(item.type == 1){
            let routerUrlArr = item.url.split("/");
            let routerName =routerUrlArr.length>2?routerUrlArr[pathArr.length-2]:( routerUrlArr[1] || routerUrlArr[0] );
            if( routerName == activePathName){
              result = item;
              break;
            }
          }else if(item.list && item.list.length > 0){
            result = this.recursion(item.list, path);
          }
        }
        return result;
      },
    }
  }
</script>
<style lang="less" scoped>


  .site-sidebar__menu{

    /*.home.is-active{*/
    /*  color: #1965FF !important;*/
    /*  span{*/
    /*    color: #1965FF !important;*/
    /*  }*/
    /*}*/

    /*.home:hover{*/
    /*  color: #1965FF !important;*/
    /*  span{*/
    /*    color: #1965FF !important;*/
    /*  }*/
    /*}*/

    /*/deep/ .el-submenu.is-opened{*/
    /*  background-color: #FFFFFF !important;*/
    /*  color: #333333 !important;*/
    /*  !*.el-submenu__title{*!*/
    /*  !*  color: #1965FF !important;*!*/
    /*  !*}*!*/
    /*}*/

    /deep/ .menuLevel2{
      .pointer{
        margin-left: 0px;
        width: 4px;
        height: 4px;
        border-radius: 2px;
        display: inline-block;
        background-color: #606266;
        position: absolute;
        top: 22px;
        left: 8px;
      }
      span{
        margin-left: 28px;
      }
      >ul{
        >li{
          padding-left:28px !important;

        }

      }
    }

    /deep/ .menuLeaf{
      span{
        margin-left: 28px;
      }
    }

    /*/deep/ .el-submenu__title:focus{*/
    /*  color: #333333 !important;*/
    /*}*/
    /*/deep/ .el-submenu__title:hover{*/
    /*  color: #1965FF !important;*/
    /*  >.pointer{*/
    /*    background-color: #1965FF !important;*/

    /*  }*/
    /*  >.el-submenu__icon-arrow{*/
    /*    color: #1965FF !important;*/
    /*  }*/
    /*}*/


    /*/deep/ .menuLeaf:active{*/
    /*  background-color: #1965FF !important;*/
    /*  color: #FFFFFF !important;*/
    /*}*/
    /*/deep/ .menuLeaf.is-active{*/
    /*  background-color: #1965FF !important;*/
    /*  color: #FFFFFF !important;*/
    /*}*/

    /*/deep/ .menuLeaf:focus{*/
    /*  background-color: #1965FF !important;*/
    /*  color: #FFFFFF !important;*/
    /*}*/
    /*/deep/ .menuLeaf:hover{*/
    /*  background-color: #1965FF !important;*/
    /*  color: #FFFFFF !important;*/
    /*}*/

    /*/deep/ ul.el-menu{*/
    /*  background-color:#FFFFFF !important;*/
    /*  color: #333333 !important;*/
    /*}*/

  }


  /*.el-menu{*/

  /*  li{*/
  /*    !*padding-left: 28px!important;*!*/
  /*  }*/
  /*  li:nth-child(1){*/
  /*    height: 65px;*/
  /*    line-height: 65px;*/
  /*  }*/
  /*  .el-divider--horizontal{*/
  /*    margin: 0;*/
  /*  }*/
  /*}*/
</style>
